// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N40A } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SearchFooter = styled.div({
  width: '100%',
  height: "var(--ds-space-600, 48px)",
  borderTop: "1px solid ".concat("var(--ds-border, ".concat(N40A, ")"))
});